import { Component, ChangeDetectionStrategy } from '@angular/core';
import { tap } from 'rxjs';
import { BasicResult } from 'src/app/core-module/models/basic-result';
import { SupportRequest } from 'src/app/core-module/models/CustomerSupport/support-request';
import { UserLocationSave } from 'src/app/core-module/models/user-location-save';
import { UserLocation } from 'src/app/core-module/models/UserManagement/user-location';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
    selector: 'app-customer-support',
    templateUrl: './customer-support.component.html',
    styleUrl: './customer-support.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerSupportComponent {


  public requestSubmitted: boolean = false;
  public currentlySelectedAudit: UserLocationSave = new UserLocationSave();
  public LocalAudits: UserLocationSave[] = [];
  public showLocalAudit: boolean = false;
  public hasSelectedAudit: boolean = false;
  public extraDetails: string = "";
  public sendingRequest:boolean = false;

  constructor(private auditService: AuditService, private util: UtilService, private toastr:ToastrService) {
    this.getLocalAudits();
  }

  validateSend() {
    if (this.extraDetails.length != 0 || this.hasSelectedAudit) {
      return true;
    } else {
      return false;
    }

  }

  getLocalAudits() {
    this.auditService.getLocalAudits().pipe(tap((res:UserLocationSave[]) => {
      res.forEach(e => {
        this.LocalAudits.push(new UserLocationSave(e));
      })
    })).subscribe();
  }
  changeShowLocalAudit() {
    this.showLocalAudit = !this.showLocalAudit;
  }
  selectedAudit(ULS: UserLocationSave) {
    this.currentlySelectedAudit = ULS;
    this.hasSelectedAudit = true;
  }
  removeAudit() {
    this.currentlySelectedAudit = new UserLocationSave();
    this.hasSelectedAudit = false;
  }
  humaniseDate(entryDate: Date): string {
    return this.util.humanDate(entryDate);
  }

  sendRequest() {
    if (this.sendingRequest) {
      return;
    }
    this.sendingRequest = true;
    var sr: SupportRequest = new SupportRequest();
    sr.AuditDetails = JSON.stringify(this.LocalAudits);
    sr.RequestDetails = this.extraDetails;
    this.auditService.sendSupportRequest(sr).pipe(tap((res:BasicResult) => {
      if (res.IsError) {
        this.toastr.addToastr(new Toastr({Type: 3, Message: "Unable to submit request, please try again."}));
        console.error(res.ErrorCode)
      }else{
        this.requestSubmitted = true;
      }
      this.sendingRequest = false;
    })).subscribe()
  }

}
